const ICON_SIDEBAR_CLOSE = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.7}
      d="M7.053 2.48 9.65 5 7.053 7.52"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.7}
      d="M4.405 5h5.244M.35.35v9.3"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default ICON_SIDEBAR_CLOSE;
